<template>
    <div class="ba6-profile-modal-all" :id="modalId"
         @click="setToggleModal ? toggleModal() : ''"
    >
        <div class="ba6-profile-backdrop"></div>
        <div :class="['ba6-profile-modal ', modalId]"
             @mouseleave="setToggleModal = true" @mouseover="setToggleModal = false"
        >
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: "ba6-modal",
    props: {
        modalId: {
            type: String,
            required: true
        }
    },
    data() {
      return {
        setToggleModal: true
      }
    },
    methods: {
      toggleModal() {
        $(`#${this.modalId}`).toggle('hide');
      }
    }
}
</script>

<style scoped lang="scss">
    .ba6-profile-modal-all{
        display: none;
        position: fixed;
        z-index: 2049;
        .ba6-profile-backdrop{
            opacity: 0.5;
            background: black;
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
        }
        .ba6-profile-modal{
            position: fixed;
            z-index: 2050;
            top: 60px;
            left: 50%;
            width: 60%;
            transform: translateX(-50%);
            padding: 20px;
            min-width: 300px;
            border-radius: 16px;
            background-color: #fff;
            .ba-card{
                gap: 32px;
                height: 100%;
                .ba-top{
                    .ba-title{
                        color: #4D5D71;
                        font-size: 22px;
                        font-weight: 700;
                    }
                    .ba-btn-close{
                        builderall-icon{
                            --builderall-icon-size: 24px;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/account-settings/components/ModalV6.vue